module.exports = __webpack_public_path__ + "img/airtke_store.eb512d18.jpg";